import axios from 'axios'

const RESOURCE_NAME = 'api/v1/Authentication/login'

export const authenticationService = {
    getAuthNRequest,
    decrypt,
    logout
};

function getAuthNRequest() {
    var authNRequest = axios.post(`${process.env.VUE_APP_ROOT_MX_AUTH_API_URL}/${RESOURCE_NAME}`)
        .then(response => {
            if (response.status === 200) {
                return response.data;
            }
        })
        .catch(error => {
            if (error.response.status === 401) {
                return Promise.reject(error.response.statusText);
            }
        });
    return authNRequest;
}

function decrypt(userClaims) {
    // Decode the escaped Base64 string
    const base64String = decodeURIComponent(userClaims);
    // Convert Base64 string to JSON
    const jsonString = atob(base64String);
    return JSON.parse(jsonString);
}
function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('userClaims');
}